var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDistributorSidebarLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.809,
    height: 18.492,
    viewBox: "0 0 15.809 18.492",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_67",
    "data-name": "Group 67",
    transform: "translate(-495.691 -751.94)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M515.664,768.04a1.564,1.564,0,1,1-.6.119,1.547,1.547,0,0,1,.6-.119",
    transform: "translate(-11.808 -10.191)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M509.427,758.771a3.589,3.589,0,1,1,4.331,0",
    transform: "translate(-7.736 0)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M524.489,773.952a7.671,7.671,0,0,1,3.051,1.76",
    transform: "translate(-18.42 -14.022)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M496.066,781.319a7.769,7.769,0,0,1,5.586-7.443",
    transform: "translate(0 -13.973)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-settings",
    "data-name": "Icon feather-settings",
    transform: "translate(503.765 762.696)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    "data-name": "Path 308",
    d: "M15.507,14.5a1,1,0,1,1-1-1A1,1,0,0,1,15.507,14.5Z",
    transform: "translate(-10.823 -10.823)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    "data-name": "Path 309",
    d: "M7.656,6.184a.552.552,0,0,0,.11.609l.02.02a.67.67,0,1,1-.947.947l-.02-.02a.557.557,0,0,0-.944.395v.057a.669.669,0,1,1-1.338,0v-.03a.579.579,0,0,0-.97-.395l-.02.02A.67.67,0,1,1,2.6,6.84l.02-.02a.557.557,0,0,0-.395-.944H2.169a.669.669,0,1,1,0-1.338H2.2a.579.579,0,0,0,.395-.97l-.02-.02A.67.67,0,1,1,3.521,2.6l.02.02a.552.552,0,0,0,.609.11h.027a.552.552,0,0,0,.335-.505V2.169a.669.669,0,1,1,1.338,0V2.2a.557.557,0,0,0,.944.395l.02-.02a.67.67,0,1,1,.947.947l-.02.02a.552.552,0,0,0-.11.609v.027a.552.552,0,0,0,.505.335h.057a.669.669,0,1,1,0,1.338h-.03a.552.552,0,0,0-.505.335Z",
    transform: "translate(-1.5 -1.5)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistributorSidebarLogo);
export default __webpack_public_path__ + "static/media/distributorSidebarLogo.9d29dc954115392f0f4704ec7946a81b.svg";
export { ForwardRef as ReactComponent };